import { Component, EventEmitter, Input, Output } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';

export interface CardFieldsPair {
  cardId: string;
  pin: string;
}

@Component({
  selector: 'app-card-entry',
  templateUrl: './card-entry.component.html',
  styleUrls: []
})
export class CardEntryComponent {

  @Output() onFieldsPairUpdate = new EventEmitter<CardFieldsPair>();
  @Input() cardId?: string | null;
  cardValidationForm: FormGroup;

  constructor(private formBuilder: FormBuilder) {
    this.cardValidationForm = this.formBuilder.group({
      cardIdField: ['', Validators.required],
      pinField: ['', Validators.required]
    });
  }

  ngOnInit(): void {
    if(this.cardId) {
      const control = this.cardValidationForm.controls['cardIdField'];
      control.setValue(this.cardId);
    }
    this.cardValidationForm?.controls['cardIdField'].valueChanges.subscribe(this.onFieldsChange.bind(this));
    this.cardValidationForm?.controls['pinField'].valueChanges.subscribe(this.onFieldsChange.bind(this));
  }

  onFieldsChange() {
    this.onFieldsPairUpdate.emit({
      cardId: this.cardValidationForm.controls['cardIdField'].value,
      pin: this.cardValidationForm.controls['pinField'].value
    })
  }

}
